import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDbMesureUnite } from './AloDbMesureUnite';

export interface IAloDbMesureTypeConstParam extends IAloDbBaseConstParam {
    MET_ID:number|null
    MUT_ID:number|null
    UMT_ID:number|null 
    UMT_KEY:string|null
    MET_KEY:string|null
    MET_LIBELLE:string|null    
    MET_DATADD:string|null
    MET_DATDEL:string|null
    MET_DATANAME_RX:string|null
    MET_IS_CALC:boolean|null
    MET_CONFIG_JSON:string|null
    MET_EXP_OFFSET:number|null   
    mesureUniteEx:IAloDbMesureTypeConstParam|null
  }

export class AloDbMesureType extends AloDbBase {
        
    public MET_ID:number|null
    public MUT_ID:number|null  
    public UMT_ID:number|null
    public UMT_KEY:string|null
    public MET_KEY:string|null
    public MET_LIBELLE:string|null
    public MET_DATADD:Date|null
    public MET_DATDEL:Date|null
    public MET_DATANAME_RX:string|null
    public MET_IS_CALC:boolean|null
    public MET_CONFIG_JSON:string|null
    public MET_EXP_OFFSET:number|null
    public mesureUniteEx:AloDbMesureUnite|null
    
    constructor({MET_ID,MUT_ID,UMT_ID,UMT_KEY,MET_KEY,MET_LIBELLE,MET_DATADD,MET_DATDEL,MET_DATANAME_RX,MET_IS_CALC,MET_CONFIG_JSON,MET_EXP_OFFSET,mesureUniteEx,...args }:IAloDbMesureTypeConstParam = {} as IAloDbMesureTypeConstParam) {
        super(args)
        this.MET_ID = MET_ID
        this.MUT_ID = MUT_ID
        this.UMT_ID = UMT_ID        
        this.UMT_KEY = UMT_KEY
        this.MET_KEY = MET_KEY   
        this.MET_LIBELLE = MET_LIBELLE   
        this.MET_DATADD =  MET_DATADD?new Date(MET_DATADD):null
        this.MET_DATDEL =  MET_DATDEL?new Date(MET_DATDEL):null
        this.MET_DATANAME_RX = MET_DATANAME_RX   
        this.MET_IS_CALC = MET_IS_CALC   
        this.MET_CONFIG_JSON =  MET_CONFIG_JSON
        this.MET_EXP_OFFSET = MET_EXP_OFFSET
        this.mesureUniteEx = mesureUniteEx?AloDbMesureUnite.createAloDbMesureUniteWithDetail(mesureUniteEx):null
    }

    static createAloDbMesureTypeArray(datas:any) {
        return new AloBaseArray(AloDbMesureType,datas)
    }

    static createAloDbMesureTypeWithDetail(data:any) {
        return new AloDbMesureType({...data,detailLoaded:true})
    }
}
